import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Header.css';

function Header({ isHomePage = false }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  
  const handleGetAppClick = (e) => {
    e.preventDefault();
    
    if (location.pathname === '/') {
      // If we're on the homepage, just scroll
      const element = document.getElementById('get-it');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // If we're on another page, navigate to homepage with hash
      navigate('/#get-it');
      // Wait for navigation and then scroll
      setTimeout(() => {
        const element = document.getElementById('get-it');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <header className={`header${isHomePage ? ' header-home' : ''}`}>
      <div className="header-container">
        <div className="header-content">
          <div className="header-inner">
            <Link to="/" className="logo">
              <img src={isHomePage ? '/assets/home/taptrap-logo.svg' : '/assets/taptrap-logo.svg'} alt="TapTrap" />
            </Link>
            
            <nav className="nav">
              <a href={t('links.followUs')} className="btn secondary sm no-border">{t('header.followUs')}</a>
              <a href="#get-it" onClick={handleGetAppClick} className="btn primary sm">
                <img className="btn-icon" src="/assets/mobile-phone.svg" alt="Phone Icon" />
                {t('header.getTheApp')}
              </a>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
